import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

interface TabOption {
  value: string;
  label: string;
}

interface SectorTabsSidebarProps {
  tabs: TabOption[];
  value: string;
  onChange: (newValue: string) => void;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const SectorTabsSidebar: React.FC<SectorTabsSidebarProps> = ({
  tabs,
  value,
  onChange,
  collapsed,
  setCollapsed,
}) => (
  <Box
    sx={{
      width: collapsed ? '0px' : '200px',
      minWidth: collapsed ? '0px' : '200px',
      transition: 'width 0.2s, min-width 0.2s',
      background: collapsed ? 'transparent' : '#f5f6fa',
      height: '100%',
      borderRight: collapsed ? 'none' : '1px solid #e0e0e0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      position: 'sticky',
      top: 0,
      zIndex: 1,
    }}
  >
    <IconButton
      onClick={() => setCollapsed(!collapsed)}
      size="small"
      sx={{
        position: 'absolute',
        top: 40,
        right: -16,
        background: '#fff',
        border: '1px solid #e0e0e0',
        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
        zIndex: 2,
        width: 32,
        height: 32,
        '&:hover': {
          background: '#f5f6fa',
        },
      }}
    >
      {collapsed ? <ChevronRight /> : <ChevronLeft />}
    </IconButton>
    {!collapsed && (
      <Box sx={{ flex: 1, width: '100%' }}>
        {tabs.map((tab) => (
          <Box
            key={tab.value}
            onClick={() => onChange(tab.value)}
            sx={{
              cursor: 'pointer',
              px: 2,
              py: 1.5,
              width: '100%',
              background: value === tab.value ? '#e3eafc' : 'transparent',
              fontWeight: value === tab.value ? 600 : 400,
              color: value === tab.value ? '#1976d2' : '#222',
              borderLeft: value === tab.value ? '4px solid #1976d2' : '4px solid transparent',
              textAlign: 'left',
              transition: 'all 0.2s',
            }}
          >
            <Typography variant="body1" noWrap>
              {tab.label}
            </Typography>
          </Box>
        ))}
      </Box>
    )}
  </Box>
);

export default SectorTabsSidebar;
